import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { from, Observable } from 'rxjs';

import { AccountService } from './account.service';
import { UserService } from './user.service';
import {UserRole} from '../models/user/user-role';

@Injectable()
export class TenantAuthGuard implements CanActivate, CanActivateChild {

    constructor(private accountService: AccountService, private _router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.checkIsTenant(state);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.checkIsTenant(state);
    }

    private checkIsTenant(state: RouterStateSnapshot): boolean | Observable<boolean> {
        const isLoggedIn = this.accountService.isLoggedIn();
        if (!isLoggedIn) {
            return from(this._router.navigate(['/login'], { queryParams: { redirect_to: state.url } }))
                .pipe(map(() => false));
        }

        const user = this.accountService.getCurrentUser();
        if(user){
            if (user.isManager && !user.isTenant) {
                return from(this._router.navigate(['/manage']))
                    .pipe(map(() => false));
            }
            else if (user.isOwner && !user.isTenant) {
                return from(this._router.navigate(['/owner']))
                    .pipe(map(() => false));
            }
            else if (user.isSupplier && !user.isTenant) {
                return from(this._router.navigate(['/supplier']))
                    .pipe(map(() => false));
            }
            else if (user.isViewing && user.unclaimedAccount === true && !user.isTenant) {
                return from(this._router.navigate(['/my-viewings/messages']))
                    .pipe(map(() => false));
            }
            else if(this.accountService.accessTokenHasRole(UserRole.YOUR_PLACE_STAFF)){
                return from(this._router.navigate(['/your-place']))
                    .pipe(map(() => false));
            }
            else if (!user.isTenant && !user.isViewing && !user.isLooking) {
                return from(this._router.navigate(['/find-a-home']))
                    .pipe(map(() => false));
            }
        }
        return isLoggedIn;
    }
}
